import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Global } from "../global";
import { Router } from "@angular/router";
import { Http, RequestOptions } from '@angular/http';
import { Headers } from '@angular/http';
import { AuthService } from "./auth/auth.service";
import { Observable } from "rxjs";

@Injectable()
export class FileUploadService {

  constructor(private http: HttpClient, public global: Global, private authService: AuthService,) { }

  uploadFile(path: any, file: Blob, fileName: string): Observable<any> {
    const formData = new FormData();
    formData.append('uploadedFile', file, fileName);
    return this.http.post(`${this.global.apiUrl}${path}`, formData);
  }

  uploadFileVideo(path: any, file: any): Observable<any> {
    const formData = new FormData();
    formData.append('uploadedFile', file);
    return this.http.post(`${this.global.apiUrl}${path}`, formData);
  }

  pushFileToStorage(path: any, file: File) {
    const uploadedFile: FormData = new FormData();
    uploadedFile.append("uploadedFile", file);
    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.global.apiUrl}${path}`, uploadedFile, {
          headers: new HttpHeaders().set(
            "Authorization",
            "Bearer " + this.authService.authToken.value
          )
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            if (err.status == 200) {
              resolve(err);
            } else {
              reject(err);
            }
          }
        );
    });
  }
}
